import { Star } from "lucide-react";
import { usePublicLang } from "@/contexts/PublicLangContext";
import { getPublicFileUrl } from "@/lib/api";
import ScrollReveal from "./ScrollReveal";
import { LANDING } from "@/constants/testIds";

export default function TestimonialsSection({ testimonials }) {
  const { t } = usePublicLang();
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className="py-20 md:py-28 px-5" style={{ backgroundColor: "var(--brand-secondary)" }} data-testid={LANDING.testimonialsSection}>
      <div className="max-w-6xl mx-auto">
        <ScrollReveal className="text-center mb-10 md:mb-14">
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-[#292522]">{t("landing.testimonials.sectionTitle")}</h2>
        </ScrollReveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((tst, idx) => (
            <ScrollReveal key={tst.id} delay={(idx % 3) * 0.1}>
              <div
                className="bg-[#F7F3ED] rounded-2xl p-6 md:p-7 h-full flex flex-col gap-4"
                data-testid={`${LANDING.testimonialCardPrefix}${tst.id}`}
              >
                {tst.rating && (
                  <div className="flex gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} className={`w-4 h-4 ${i < tst.rating ? "fill-[var(--brand-primary)] text-[var(--brand-primary)]" : "text-[#C0C2C4]"}`} />
                    ))}
                  </div>
                )}
                {tst.image_url ? (
                  <img src={getPublicFileUrl(tst.image_url)} alt={tst.patient_name} className="rounded-lg w-full object-cover" />
                ) : (
                  <p className="text-base leading-relaxed text-[#6B6058] italic">&ldquo;{tst.text}&rdquo;</p>
                )}
                <p className="text-sm font-medium text-[#292522] mt-auto">{tst.patient_name}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
